import { VFC } from 'react';
import { FormattedMessage } from 'react-intl';
import { MeasuringCurrentTransformer } from '@enmon/commons';
import { Select } from '../../Select';
import { MeterDetails as messages } from '../../../Form/meter_details/messages';

interface MeasuringCurrentTransformerSelectProps {
  value?: MeasuringCurrentTransformer;
  onChange?: (value: MeasuringCurrentTransformer) => void;
}

export const MeasuringCurrentTransformerSelect: VFC<MeasuringCurrentTransformerSelectProps> = ({ ...restProps }) => (
  <Select
    allowClear
    showArrow
    className="w-100"
    options={Object.values(MeasuringCurrentTransformer).map(value => ({
      value,
      label: value,
    }))}
    placeholder={<FormattedMessage {...messages.mpcPlaceholder} />}
    {...restProps}
  />
);
